import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators, UntypedFormControl, UntypedFormArray, UntypedFormGroup, FormControl } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Router, ActivatedRoute } from "@angular/router";

import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { Location } from '@angular/common';
import { ConfirmedValidator } from "src/app/common/passwordValidator";
import { formatDate } from "@angular/common";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-doctor-edit-profile',
  templateUrl: './doctor-edit-profile.component.html',
  styleUrls: ['./doctor-edit-profile.component.css']
})
export class DoctorEditProfileComponent implements OnInit {

  //multi select Dropdown
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  //------------------------

  editDoctorCurrentTab: string = 'personalInformation';
  editDoctorListOfTabs: string[] = ["personalInformation", "professionalInformation", "bankAccount"];
  forms = {
    personalInformation: null,
    professionalInformation: null,
    bankAccount: null
  };
  physician: any
  physician_speciality: UntypedFormArray;
  physician_education: UntypedFormArray;
  physician_experience: UntypedFormArray;
  // physician_illnesstreated: UntypedFormArray;
  specialitiesList: any = [];
  countries = [];
  dateFormat = Utils.DATE_FORMAT;
  states: any = [];
  smcs: any = [];
  maxDate = Utils.today;
  minDate = Utils.minDobDate;
  defaultDays = Utils.DEFAULT_DAYS;
  defaultFeeApplied: boolean = false;
  docProfileTab = Utils.DOCTORPROFILETABS;
  title = Utils.TITLE;
  public termsConditions: boolean = false;
  imgUrl: string;
  signUrl: string;
  saveAll: boolean = false;
  illness_list = [];
  phyBankAccType: string[] = [
    Utils.ACCOUNT_TYPE.SAVINGS,
    Utils.ACCOUNT_TYPE.CURRENT,
  ];

  displayNames: any = {
    from_year: 'From Year',
    to_year: 'To Year',
    country: 'Country',
    designation: 'Designation',
    employer: 'Employer',
    degree: 'Degree',
    institution: 'Institution',
    speciality_id: 'Add Speciality',
  }

  ppfile: File = null;
  signfile: File = null;
  currentDate = Utils.maxDate;
  miniDate = Utils.miniDate;
  avatartimg: any;
  physicianname: string;
  AppointmentDays: any[];
  appointmentDaysControl = new FormControl('');
  constructor(private service: VproService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService, private location: Location,
    private utils: Utils) {
    this.forms.personalInformation = this._formBuilder.group({
      title: [null],
      qualification: [null, [Validators.required]],
      r_no: [null, [Validators.required]],
      smc: [null, [Validators.required]],
      address_1: [null],
      address_2: [null],
      additional_info: [null],
      u_id: [null],
      city: [null],
      zip: [null, [Validators.pattern(Utils.zipRegex), Validators.maxLength(6)]],
      dob: [null, [Validators.required]],
      contact_no: [null, [Validators.pattern(Utils.numberRegex), Validators.maxLength(12), Validators.minLength(10)]],
      contact_no2: [null, [Validators.pattern(Utils.numberRegex), Validators.maxLength(12), Validators.minLength(10)]],
      email_id2: [null, [Validators.pattern(Utils.emailpat)]],
      AppointmentDays: [null],
      //physician_qualification: this._formBuilder.array([]),
      ppurl: [null],
      s_url: [null],
      pp_content_type: [null],
      surl_content_type: [null],
      state: [null],
      fee: [null],
      fee_patient: [null],
      followup_fee: [null],
      followup_fee_patient: [null],
      followup_days: [null],

    });

    this.forms.professionalInformation = this._formBuilder.group({
      physician_speciality: this._formBuilder.array([]),
      physician_education: this._formBuilder.array([]),
      physician_experience: this._formBuilder.array([]),
      illness: [],

    });

    this.forms.bankAccount = this._formBuilder.group({
      /* bank_name: ['', [Validators.required, Validators.pattern(Utils.nameRegex)]],
      city: ['', Validators.required], */
      ifsc_code: ['', [Validators.required, Validators.pattern(Utils.ifscRegex)]],
      beneficiary_name: ['', [Validators.required, Validators.pattern(Utils.nameRegex)]],
      account_type: ['', [Validators.required, Validators.pattern(Utils.alphaRegex)]],
      account_number: ['', [Validators.required, Validators.pattern(Utils.accountNumberRegex)]],
      confirm_account_number: ['', [Validators.required, Validators.pattern(Utils.accountNumberRegex),]]
    },
      {
        validator: ConfirmedValidator('account_number', 'confirm_account_number')
      });

  }

  ngOnInit() {
    this.getIllnessList();
    this.getSpecialitiesList();
    this.route.params.subscribe(routeParams => {
      this.loadPhysician();
      this.loadCountries();
    });

    this.AppointmentDays = [

      { id: 0, Days: '0' },
      { id: 1, Days: '1' },
      { id: 2, Days: '2' },
      { id: 3, Days: '3' },
      { id: 4, Days: '4' },
      { id: 5, Days: '5' },
      { id: 6, Days: '6' },
      { id: 7, Days: '7' }
    ]
    // this.appointmentDaysControl.setValue(this.physician.appointmentDays);

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Illness / Symptoms',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };

    //multi select dropdown Ends
  }

  getIllnessList() {
    this.spinner.show();
    this.service
      .getIllnessList()
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.illness_list = res;


          this.illness_list.forEach(x => {
            x.itemName = x.illness;
            delete x.illness;
            delete x.ill_status;
          });
          console.log("Illness lIst", this.illness_list);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }


  //multi select dropdown strats
  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }

  //multi select dropdown Ends 

  loadCountries() {
    this.service
      .getMasterList("countries")
      .subscribe((res) => (this.countries = res));
    // this.physician?.physician_education?.country = this.countries.find(x => x.id == this.physician.country)
  }

  loadPhysician() {
    this.spinner.show();
    this.service.getPhysicianById(this.route.snapshot.params["id"], '?fields=physician_bank_details').subscribe(
      (response) => {
        this.spinner.hide();
        console.log("RESPONSE:", response);
        if (response) {
          this.physician = response;
          console.log(" this.physician ======================", this.physician)
          if (this.physician && this.physician.physician_qualification) {
            if (this.physician.physician_qualification[0].qualification)
              this.physician.qualification = this.physician.physician_qualification[0].qualification;
            if (this.physician.physician_qualification[0].r_no)
              this.physician.r_no = this.physician.physician_qualification[0].r_no;
            if (this.physician.physician_qualification[0].smc)
              this.physician.smc = this.physician.physician_qualification[0].smc;
          }

          if (this.physician && this.physician.physician_consultfee) {
            if (this.physician.physician_consultfee[0].fee >= 0) {
              this.physician.fee = this.physician.physician_consultfee[0].fee;
              if (this.physician.consultation_share) {
                this.physician.fee_patient = this.physician.fee + ((1 - this.physician.consultation_share) * this.physician.fee);
                this.physician.fee_patient = Math.ceil(this.physician.fee_patient)
              }
            }
            if (this.physician.physician_consultfee[0].followup_fee >= 0) {
              this.physician.followup_fee = this.physician.physician_consultfee[0].followup_fee;
              if (this.physician.consultation_share) {
                this.physician.followup_fee_patient = this.physician.followup_fee + ((1 - this.physician.consultation_share) * this.physician.followup_fee);
                this.physician.followup_fee_patient = Math.ceil(this.physician.followup_fee_patient)
              }
            }
            if (this.physician.physician_consultfee[0].followup_days)
              this.physician.followup_days = this.physician.physician_consultfee[0].followup_days;
          } else
            this.physician.followup_days = this.defaultDays;

          if (this.physician && this.physician.physician_bank_details) {
            this.termsConditions = true;
            this.forms.bankAccount.patchValue(this.physician.physician_bank_details);
            this.forms.bankAccount.disable();
          }


          this.loadStates(); /* =============== Fetch States Array =============== */
          this.loadSmc(); /* =============== Fetch SMC Array =============== */
          if (this.physician && !this.physician.physician_education) {
            this.physician.physician_education = [];
          }
          if (this.physician && !this.physician.physician_experience)
            this.physician.physician_experience = [];
          if (this.physician && !this.physician.physician_speciality)
            this.physician.physician_speciality = [];
          if (this.physician && !this.physician.physician_qualification)
            this.physician.physician_qualification = [];



          //  Retain form values upon click
          this.forms.personalInformation.patchValue(this.physician);
          console.log("this.forms.personalInformation.patchValue(this.physician)", this.physician['dob'])
          let startDate = this.physician['dob'].split('-');
          this.forms.personalInformation.patchValue({
            dob: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }
          })
          this.forms.professionalInformation.patchValue(this.physician);

          this.physicianname = this.physician.first_name + ' ' + this.physician.last_name;
          console.log("physicianname", this.physicianname);
          this.avatartimg = this.physician.ppurl.substring(this.physician.ppurl.lastIndexOf('/') + 1);
          console.log("this.physician.ppurl", this.avatartimg);

          this.addSpeciality();
          this.addEducation();
          this.workExperience();
          this.physicianIllness();


        }
      },
      (error) => {
        this.spinner.hide();
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
      }
    );
  }

  loadStates(): any {
    this.spinner.show();
    this.service.getStates(1).subscribe((res) => {
      this.spinner.hide();
      this.states = res;
    });
  }

  loadSmc(): any {
    this.spinner.show();
    this.service.getMasterList("smc")
      .subscribe((res) => {
        this.spinner.hide();
        this.smcs = res;
      });
  }

  getStateName(state_id): any {
    if (this.states && this.states.length > 0) {
      let state = this.states.filter(x => {
        return JSON.parse(x.id) === JSON.parse(state_id);
      });
      if (state && state.length > 0 && state[0].name) return state[0].name;
      return '';
    }
    return '';
  }

  getSmcName(smc_id): any {
    // if (this.AppointmentDays && this.AppointmentDays.length > 0) {
    //   let AppointmentDays = this.AppointmentDays.filter(x => {
    //     return JSON.parse(x.id) === JSON.parse(smc_id);
    //   });
    //   if (AppointmentDays && AppointmentDays.length > 0 && AppointmentDays[0].Days) return AppointmentDays[0].Days;
    //   return '';
    // }
    if (this.smcs && this.smcs.length > 0) {
      let smc = this.smcs.filter(x => {
        return JSON.parse(x.id) === JSON.parse(smc_id);
      });
      if (smc && smc.length > 0 && smc[0].name) return smc[0].name;
      return '';
    }
    return '';
  }
  getAppointmentDays(days: string): string {
    const day = this.AppointmentDays.find(x => x.id === days);
    return day ? day.Days : 'Not set';
  }
  // getAppointmentDays(days): any {
  //   if (this.AppointmentDays && this.AppointmentDays.length > 0) {
  //     let AppointmentDays = this.AppointmentDays.filter(x => {
  //       return JSON.parse(x.id) === JSON.parse(days);
  //     });
  //     if (AppointmentDays && AppointmentDays.length > 0 && AppointmentDays[0].Days) return AppointmentDays[0].Days;
  //     return '';
  //   }
  //   // if (this.smcs && this.smcs.length > 0) {
  //   //   let smc = this.smcs.filter(x => {
  //   //     return JSON.parse(x.id) === JSON.parse(days);
  //   //   });
  //   //   if (smc && smc.length > 0 && smc[0].name) return smc[0].name;
  //   //   return '';
  //   // }
  //   return '';
  // }
  getTitle(t_key) {
    for (let r of this.title) {
      if (r.key === t_key)
        return r.value;
    }
  }

  getControl(field: string): UntypedFormControl {
    return this.forms.personalInformation.get(field) as UntypedFormControl;
  }

  getControls(field: string): UntypedFormControl {
    return this.forms.professionalInformation.get(field) as UntypedFormControl;
  }


  updateField(field: string) {
    if (this.editDoctorCurrentTab == this.docProfileTab.PERSONALINFORMATION) {
      const control = this.getControl(field);
      console.log("control.value ===control.value", control.value)
      if (control.valid) {
        if (field === "fee" && this.physician.consultation_share) {
          this.physician.fee_patient = parseFloat(control.value) + ((1 - this.physician.consultation_share) * parseFloat(control.value));
          this.physician.fee_patient = Math.ceil(this.physician.fee_patient);
        }
        if (field === "followup_fee" && this.physician.consultation_share) {
          this.physician.followup_fee_patient = parseFloat(control.value) + ((1 - this.physician.consultation_share) * parseFloat(control.value));
          this.physician.followup_fee_patient = Math.ceil(this.physician.followup_fee_patient)
        }
        console.log("FIELD", field)
        if (field === 'AppointmentDays') {
          // Update the physician's appointmentDays directly
          this.physician[field] = control.value;
        }
      }

      this.physician = {
        ...this.physician,
        [field]: control.value,
      };
      // if (field === 'appointmentDays') {
      //   const control = this.getControl(field);
      //   if (control.valid) {
      //     this.physician[field] = control.value;
      //   }
      // }
    } else if (this.editDoctorCurrentTab == this.docProfileTab.PROFESSIONALINFORMATION) {
      const controls = this.getControls(field);
      this.physician = {
        ...this.physician,
        [field]: controls.value,
      };
    }
  }

  createSpeciality(speciality_id, years, id): UntypedFormGroup {
    return this._formBuilder.group({
      speciality_id: [speciality_id, [Validators.required]],
      no_of_years: [years, [Validators.required]],
      id: [id]
    });
  }

  addEdRecord(degree, institution, from_year, to_year, country, id): UntypedFormGroup {
    return this._formBuilder.group({
      degree: [degree, [Validators.required]],
      institution: [institution, [Validators.required]],
      from_year: [from_year],
      to_year: [to_year],
      country: [country],
      id: [id]
    });
  }

  addExperience(employer, designation, from_year, to_year, country, id): UntypedFormGroup {
    return this._formBuilder.group({
      employer: [employer, [Validators.required]],
      designation: [designation, [Validators.required]],
      from_year: [from_year],
      to_year: [to_year],
      country: [country],
      id: [id]
    });
  }


  addSpeciality() {
    for (let item of this.physician.physician_speciality) {
      this.physician_speciality = this.forms.professionalInformation.get('physician_speciality') as UntypedFormArray;
      this.physician_speciality.push(this.createSpeciality(item.speciality_id, item.no_of_years, item.id));
    }
  }

  addEducation() {
    for (let item of this.physician.physician_education) {
      this.physician_education = this.forms.professionalInformation.get('physician_education') as UntypedFormArray;
      this.physician_education.push(this.addEdRecord(item.degree, item.institution, item.from_year, item.to_year, item.country, item.id));
    }
  }

  workExperience() {
    for (let item of this.physician.physician_experience) {
      this.physician_experience = this.forms.professionalInformation.get('physician_experience') as UntypedFormArray;
      this.physician_experience.push(this.addExperience(item.employer, item.designation, item.from_year, item.to_year, item.country, item.id));
    }
  }
  physicianIllness() {
    this.service.getPhysicianById(this.route.snapshot.params["id"], '?fields=physician_illness').subscribe(
      (response) => {
        this.spinner.hide();
        console.log("RESPONSE:Illness", response);
        this.selectedItems = response['physician_illness']
        this.selectedItems.forEach(illness => {
          illness.id = illness.illness_id
          illness.itemName = illness.illness
        });
      })
  }
  public showFormArrayVal(index, arrayName, key) {
    let val;
    val = this[arrayName].value[index][key];
    if (arrayName === 'physician_speciality' && key === 'speciality_id') {
      this.specialitiesList.forEach(element => {
        if (element.id == val) {
          val = element.name;
        }
      });
    }

    if ((arrayName === 'physician_experience' || 'physician_education') && key === 'country') {
      this.countries.forEach(element => {
        if (element.id == val) {
          val = element.name;
        }
      });
    }

    if (!val) {
      val = this.displayNames[key];
    }

    return val;
  }

  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  addNewFormArray(arrayName) {
    this[arrayName] = this.forms.professionalInformation.get([arrayName]) as UntypedFormArray;

    if (arrayName === "physician_speciality") {
      this[arrayName].push(this.createSpeciality(null, null, null));
    } else if (arrayName === "physician_education") {
      this[arrayName].push(this.addEdRecord(null, null, null, null, null, null));
    } else if (arrayName === "physician_experience") {
      this[arrayName].push(this.addExperience(null, null, null, null, null, null));
    }

  }

  public saveProfile() {
    this.saveAll = true;
    this.editProfile();
  }

  public editProfile() {
    let data: any;
    // Remove any empy fields


    if (this.editDoctorCurrentTab == this.docProfileTab.BANKACCOUNT || this.saveAll) {
      if (this.physician && !this.physician.physician_bank_details && this.checkIfDoctor()) {
        data = {};
        data['physician_bank_details'] = this.forms.bankAccount.value;
        console.log("data['physician_bank_details']", data['physician_bank_details']);
        if (data && data.physician_bank_details && data.physician_bank_details.confirm_account_number) {
          delete data.physician_bank_details.confirm_account_number;
        }
      }
    }

    if (this.editDoctorCurrentTab == this.docProfileTab.PROFESSIONALINFORMATION || this.editDoctorCurrentTab == this.docProfileTab.PERSONALINFORMATION || this.saveAll) {

      data = { ...data, ...this.forms.professionalInformation.value };
      data = Utils.removeNullAndEmpty(data);

      if (data.physician_education && data.physician_education.length > 0) {
        data.physician_education.forEach((x, index) => {
          data.physician_education[index] = Utils.removeNullAndEmpty(x);
        })
      }

      if (data.physician_experience && data.physician_experience.length > 0) {
        data.physician_experience.forEach((x, index) => {
          data.physician_experience[index] = Utils.removeNullAndEmpty(x);
        })
      }

      if (data.physician_speciality && data.physician_speciality.length > 0) {
        data.physician_speciality.forEach((x, index) => {
          data.physician_speciality[index] = Utils.removeNullAndEmpty(x);
        })

        data.physician_speciality.forEach((x, index) => {
          x.no_of_years = x.no_of_years.toString();
        })
      }
      if (this.editDoctorCurrentTab == this.docProfileTab.PERSONALINFORMATION || this.saveAll) {
        data = { ...data, ...this.forms.personalInformation.value };
        data = Utils.removeNullAndEmpty(data);
        if (data.dob) {
          // data.dob = formatDate(data.dob, "yyyy-MM-dd", "en-US");
          data.dob = data.dob.year + "-" + data.dob.month + "-" + data.dob.day
        }
        //Check if image not changed
        if (this.forms.personalInformation.value.ppurl === this.physician.ppurl) {
          delete data.ppurl;
        }
        if (this.forms.personalInformation.value.s_url === this.physician.s_url) {
          delete data.s_url;
        }
        if (this.forms.personalInformation.value.AppointmentDays) {
          data.aptinterval = parseInt(data.AppointmentDays)
          delete data.AppointmentDays;
        }
        if (this.physician.fee >= 0)
          data.fee = this.physician.fee;

        if (this.physician.followup_fee >= 0)
          data.followup_fee = this.physician.followup_fee;

        if (data.followup_days)
          data.followup_days = Number(data.followup_days);

        if (data.fee_patient)
          delete data.fee_patient;

        if (data.followup_fee_patient)
          delete data.followup_fee_patient;
      }

    }
    if (data.illness)
      data.illness.forEach((x, index) => {
        delete x.illness_id;
        delete x.illness;
      })
    data = Utils.removeNullAndUndefined(data);

    data['u_id'] = this.route.snapshot.params["id"];
    data['org_code'] = localStorage.getItem("orgcode");
    this.spinner.show();
    this.service.updatePhysician(this.route.snapshot.params["id"], data, this.ppfile, this.signfile).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        this.showToast('success', "Physician profile has been updated successfuly");
        if (this.editDoctorCurrentTab == this.docProfileTab.BANKACCOUNT)
          this.forms.bankAccount.disable();
      },
      (error) => {
        this.spinner.hide();
        let message;
        if (error && error.error && error.error.message && error.error.message.message) {
          message = error.error.message.message;
        }
        else message = "Something went wrong. Couldn't update profile."
        this.showToast('error', message);
      }
    );
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  /** assign tabs based on click */
  public editDoctorAssignTab(tabName: string): void {
    this.editDoctorCurrentTab = tabName;

  }

  /** next tabs based on next click by user */
  public doctorEditNextTab(): void {
    let index = this.editDoctorListOfTabs.indexOf(this.editDoctorCurrentTab);
    this.editDoctorCurrentTab = this.editDoctorListOfTabs[index + 1];
  }
  /** get previous tabname and info */
  public doctorEditPreviousTab(): void {
    let index = this.editDoctorListOfTabs.indexOf(this.editDoctorCurrentTab);
    this.editDoctorCurrentTab = this.editDoctorListOfTabs[index - 1];
  }

  public removeFromList(list, i) {
    this[list].removeAt(i);
  }

  formValidation(i, key, arrayName) {
    let error = false;
    if (this.forms['professionalInformation'].get([arrayName]).controls[i] &&
      this.forms['professionalInformation'].get([arrayName]).controls[i].controls[key] &&
      this.forms['professionalInformation'].get([arrayName]).controls[i].controls[key].errors) {
      error = true;
    }
    return error;

  }

  public fileSelected(event) {
    if (event.target.files[0].type && event.target.files[0].type.indexOf('image') === -1 || !Utils.allowedImageFormats.includes(event.target.files[0].type.split('/').pop())) {
      const Toast = Swal.mixin({
        position: 'top',
        showConfirmButton: true,
        allowOutsideClick: false,
      });

      Toast.fire({
        type: 'warning',
        title: 'Only .png/.jpeg/.jpg format is allowed',

      });


    }
    else {
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]); // read file as data url

        reader.onload = (e: Event) => { // called once readAsDataURL is completed
          if (e && e.target && e.target['result']) {
            if (event.target['id'] === Utils.URLTYPE.SIGNURL)
              this.physician.s_url = e.target['result'];
            else
              this.physician.ppurl = e.target['result'];
          }
        }

        // now update ppurl file to send in api
        if (event.target['id'] === Utils.URLTYPE.IMGURL) {
          this.ppfile = event.target.files[0];
          this.forms.personalInformation.patchValue({
            ppurl: event.target.files[0].name,
            pp_content_type: event.target.files[0].type
          });
        } else {
          this.signfile = event.target.files[0];
          this.forms.personalInformation.patchValue({
            s_url: event.target.files[0].name,
            surl_content_type: event.target.files[0].type
          });
        }
      }
    }
  }
  getback() {
    this.location.back();
  }

  public checkIfDoctor() {
    let loggedInUser = JSON.parse(localStorage.getItem('LogUsrTyp'));
    if (loggedInUser) return this.utils.checkRoleType(Utils.USER_TYPE.physician, loggedInUser) && this.route.snapshot.params["id"] == JSON.parse(localStorage.getItem('uid'));
    return false;
  }
}
